module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8Qdnj"))).then(() => parcelRequire('ikE14'));